import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ComparisonCompareTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonCompare.trackingInfo";

import * as TrackingProductMapper from "@/services/tracking/mappers/product.mapper";
import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: ComparisonCompareTrackingInfo) => {
    const event: TypedAnalyticsEvent<ComparisonCompareTrackingInfo> = {
        event: EventType.ComparisonCompare,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackProducts = (
    products: Array<Product<ProductFieldSet.ProductTile>>
) => {
    const trackingProducts = products.map(
        TrackingProductMapper.toTrackingProduct
    );

    track({
        products: trackingProducts
    });
};
